import React from 'react';
import styled from 'styled-components';
import Seaturtle from '../../components/Seaturtle/Seaturtle';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardSeaturtle extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Seaturtle/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Nests on Tropical Beaches"
   diagnosis="Sea turtles balance the oceans' food webs. By grazing, they help maintain seagrass beds, and coral reefs. They also control the jellyfish population, which feed on fish larvae."
   prediction="Despite associated protection measures, six of seven sea turtle species are still considered endangered (by ESA), and some populations continue to decline (Oceana)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardSeaturtle;


